import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { User } from '../models/auth.models';
import { ConfigService } from '../../ConfigService';
import { CambioContrasena } from '../models/CambioContrasena';


@Injectable({ providedIn: 'root' })
export class AuthfakeauthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(usuario: string, password: string,ruc: string) {
      console.log(ConfigService.settings.apiUrl)
        return this.http.post<any>(ConfigService.settings.apiUrl+  `Usuarios/Login?usuario=`+usuario+"&clave="+password+"&ruc="+ruc, "")
            .pipe(map(user => {
                // login successful if there's a jwt token in the response
                if (user && user.Nombre) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                    this.currentUserSubject.next(user);
                }

                return user;
            }), catchError( error => {
              return throwError( error );
            })

            );
    }
    cambiarcontrasena(params: CambioContrasena): Observable<boolean>{
      return this.http.post<boolean>(ConfigService.settings.apiUrl+"Erusuarios/cambiarcontrasena", params )
   }
    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }



}
